<template>
  <el-scrollbar class="link-container">
    <div class="link-info">
      <h3 class="info-item__h3">基本信息</h3>
      <div class="link-static">
        <div class="link-static-item">
          <label class="link-static-label">规则名称：</label>
          <label class="link-static-label-two">{{ logData.ruleName }}</label>
        </div>
        <div class="link-static-item link-static-none">
          <label class="link-static-label">规则优先级：</label>
          <label class="link-static-label-two">{{ logData.levelNum }}</label>
        </div>
        <div class="link-static-item">
          <label class="link-static-label">规则说明：</label>
          <label class="link-static-label-two">{{ logData.description }}</label>
        </div>
        <div class="link-static-item link-static-none">
          <label class="link-static-label">触发时间：</label>
          <label class="link-static-label-two">{{ logData.triggerTime }}</label>
        </div>
        <div class="link-static-item">
          <label class="link-static-label">告警设备：</label>
          <label class="link-static-label-two">{{ logData.deviceName }}</label>
        </div>
        <div class="link-static-item link-static-none">
          <label class="link-static-label">设备ID：</label>
          <label class="link-static-label-two">{{ logData.deviceId }}</label>
        </div>
        <div class="link-static-item">
          <label class="link-static-label">告警事件：</label>
          <label class="link-static-label-two">{{ logData.eventName }}</label>
        </div>
        <div class="link-static-item link-static-none">
          <label class="link-static-label">告警编号：</label>
          <label class="link-static-label-two">{{ logData.alarmNum }}</label>
        </div>
        <div class="link-static-item">
          <label class="link-static-label">告警级别：</label>
          <label class="link-static-label-two">{{ logData.alarmLevel }}</label>
        </div>
        <div class="link-static-item link-static-none">
          <label class="link-static-label">联动结果：</label>
          <label class="link-static-label-two">{{ logData.state }}</label>
        </div>
      </div>
    </div>
    <div class="link-info" style="flex: 1;position: relative;margin-bottom: 0">
      <h3 class="info-item__h3">联动动作</h3>
      <!-- <div class="flex-info" style="position: absolute;right: 45px;top: 16px;cursor: pointer">
        <span class="soc iconPreview" style="font-size: 14px;color: #5d89e0" @click="handleOpenMap">&nbsp;地图显示设备</span>
      </div> -->
      <el-table :data="logData.actionLogs" style="margin-top: 20px">
        <el-table-column label="设备名称" prop="deviceName" width="230" show-overflow-tooltip>
          <template slot-scope="scope">
            <div>
              <i :class="['soc', hasClass(scope.row.deviceType)]"></i>
              <span style="margin-left: 3px">{{ scope.row.deviceName }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="联动动作" prop="doAction" show-overflow-tooltip>
          <template slot-scope="scope">
            <div style="display: flex;justify-content: space-between">
              <!-- <span style="color: rgb(64, 122, 238);cursor: pointer" @click="handleClick(scope.row)">{{
                hasActionName(scope.row.doAction) }}</span> -->
              <span>{{ hasActionName(scope.row.doAction) }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="执行顺序" prop="orderNum" show-overflow-tooltip />
        <el-table-column label="执行时间" prop="executeTime" width="140" show-overflow-tooltip />
        <el-table-column label="执行结果" prop="state" show-overflow-tooltip />
      </el-table>
    </div>
    <!-- <dhWindowPlayer ref="videoPlayer"></dhWindowPlayer> -->
  </el-scrollbar>
</template>

<script>
// import dhWindowPlayer from "@src/components/business/dh-window-player/index.vue";
export default {
  name: "linkRecordInfo",
  props: {
    logData: {
      type: Object,
      default: () => {
      }
    }
  },
  components: {
    // dhWindowPlayer
  },
  data() {
    return {}
  },
  mounted() {
  },
  methods: {
    handleOpenMap() { },
    handleClick(val) {
      if (val.doAction === 3) {
        // this.$player.OcxPlayer.open({
        //   cameraCode: val.thirdDeviceId,
        //   cameraName: val.deviceName,
        //   playType: 'back',
        //   backStartTime: val.startTime.replace(/-/g, '/'),
        //   backEndTime: val.endTime.replace(/-/g, '/'),
        //   layOut: 1,
        //   x: 419
        // });
        // console.log(val, 'test')
        let options = {
          endTime: new Date(val.endTime).getTime(),
          playId: val.thirdDeviceId,
          playTitle: "录像回放",
          playType: "back",
          startTime: new Date(val.startTime).getTime(),
        }
        // console.log(options, 'options')
        // this.$refs.videoPlayer.showWnd(options);
      } else {
        // this.tipVisible = true;
        // let par = {
        //   actionCode: val.doAction,
        //   thirdDeviceId: val.thirdDeviceId,
        //   deviceId: val.deviceId,
        //   executeTime: val.executeTime
        // };
        // getImagesByAction(par).then(res => {
        //   if (res.success) {
        //     this.imgData = res.data.image;
        //   }
        // });
        let param = {
          actionCode: val.doAction,
          thirdDeviceId: val.thirdDeviceId,
          deviceId: val.deviceId,
          executeTime: val.executeTime
        };
        this.$fetch('/bas/linkage-rule/log/getImages.json', param).then(res => {
          if (res.success) {
            console.log(res)
          }
        })
      }
    },
    hasActionName(val) {
      switch (val) {
        case 1:
          return '抓拍';
        case 2:
          return '人脸抓拍';
        case 3:
          return '录像';
        case 4:
          return '开门';
        case 5:
          return '关门';
      }
    },
    /**
     * 列表样式
     * @param type
     */
    hasClass(type) {
      switch (type) {
        case 18:
          return 'iconGunMachine';
        case 1102:
          return 'iconGunMachine';
        case 1103:
          return 'iconBallMachine';
        case 1104:
          return 'iconHalfMachine';
        case 1105:
          return 'iconGunMachine';
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.link-container {
  display: flex;
  flex-direction: column;
  flex: 1;

  .flex-info {
    cursor: pointer;
    display: flex;
    align-items: center
  }

  .link-info {
    width: 100%;
    border-style: solid;
    border-width: 1px;
    border-color: #394567;
    min-width: 100px;
    padding: 16px;
    margin-bottom: 32px;
  }

  .info-item__h3 {
    // color: #fff;
    color: #000000;
    border-left-width: 3px;
    border-left-style: solid;
    padding-left: 10px;
    line-height: 20px;
    border-left-color: #407AEE;
  }

  .link-static {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;

    &-item {
      // background-color: #2B3452;
      background-color: #EBEEF5;
      padding: 6px 10px;
      line-height: 20px;
      width: 326px;
      margin-right: 20px;
      margin-top: 16px;
      display: flex;
      flex-direction: row;
      align-items: center;
      word-break: break-all;

      &:nth-child(2n) {
        margin-right: 0;
      }
    }

    &-label {
      margin-right: 10px;
    }

    &-label-two {
      flex: 1;
    }
  }
}
</style>
